// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getAll: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/employments', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setEmployments', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    get: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/employment/' + payload.employment_id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments
                }
            }
          ).then(res => {
            commit('setEmployment', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    update: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const employment = payload.employment;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/employment', {
            ...employment,
        }, {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments
            }
        });
    }
}

export default actions
